<template>
  <div class="device-container">
    <div class="devices-list">

      <div v-if="devices" v-for="device in devices" @click="handleDeviceClick(device)" class="device-item"
           :class="{'selected':selectedDevice===device}">
        <div class="device-icon">
          <i class="icon-device"></i>
        </div>
        <div class="device-info">
          device Info
        </div>
        <div class="actions"></div>
      </div>

    </div>
    <div class="device-options">
      <deviceOptions :device="selectedDevice"></deviceOptions>
    </div>
  </div>
</template>

<script>
  import device from '../../../../Class/Device.js'
  import deviceOptions from './../device-options/deviceOptions'

  export default {
    name: "devices",
    components: {deviceOptions},
    props: {
      devices: {
        type: Array,
        default() {
          return []
        }
      }
    },
    methods: {
      handleDeviceClick(device) {
        this.selectedItem = device;
        console.log('yup', device)
      }
    },
    data() {
      return {selectedItem: null}
    }
  }
</script>

<style lang="scss" scoped>
  @import "../styles/variables";

  .device-container {
    width: 100%;
    height: 100%;
    display: flex;
    .devices-list {
      height: 100%;
      border-right: 1px solid $divider;
      width: 100%;
      overflow: auto;
      .device-item {
        width: calc(100% - 24px);
        height: 140px;
        margin-top: 16px;
        margin-left: 12px;
        background: $transparentWhite;
        border-radius: 8px;
        display: flex;
        align-items: center;
        cursor: pointer;
        border: 1px solid transparent;

        &:hover {
          border-color: rgba(241, 90, 36, .8);
        }
        &.selected {
          border-color: $blue;
        }

        .device-icon {
          height: 120px;
          width: 120px;
          background-color: rgba(0, 0, 0, .2);
          border-radius: 8px;
          margin-left: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          i {
            font-size: 6rem;
          }

        }
        .device-info {
          width: calc(76% - 150px);
          margin-left: 10px;
          height: 120px;

        }
        .actions {
          width: 24%;
          height: 40px;
        }

      }
    }
    .device-options {
      width: 100%;
      height: 100%;
    }

  }


</style>



// WEBPACK FOOTER //
// src/views/project/create-project/devices/devices.vue